module.exports = __webpack_public_path__ + "static/intro-img-c52f71ae45023a7acffb553ffab4edb5.png";